import React from "react";

const testimonios = [
  {
    mensaje:
      "Zamintech transformó nuestra empresa con su software a medida. Excelente servicio y atención al detalle.",
    nombre: "Carlos López",
    cargo: "CEO, Innovatech",
  },
  {
    mensaje:
      "El equipo de Zamintech nos asesoró con mucha paciencia y profesionalismo. Muy recomendados.",
    nombre: "Jose Cumbicus",
    cargo: "Gerente de Contaduria Online",
  },
  {
    mensaje:
      "Compré mis equipos aquí y quedé encantada. Productos de calidad y entrega rápida.",
    nombre: "Andrea Pérez",
    cargo: "Freelancer",
  },
];

const Testimonials = () => {
  return (
    <section className="py-16 px-6 bg-gray-100" id="testimonios">
      <h2 className="text-3xl font-bold text-center mb-10 text-gray-800">
        Testimonios
      </h2>

      <div className="max-w-6xl mx-auto grid gap-6 md:grid-cols-3">
        {testimonios.map((t, i) => (
          <div
            key={i}
            className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition"
          >
            <p className="text-gray-700 italic">"{t.mensaje}"</p>
            <div className="mt-4 font-semibold text-indigo-600">{t.nombre}</div>
            <div className="text-sm text-gray-500">{t.cargo}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
